import { RecoveryOverview } from "@/features/recovery/recovery-overview";

export default function RecoveryPage() {
  return <RecoveryOverview />;
}
